<template>
    <div class="articleimagesbox">
        <div class="close" @click="callback">X</div>
        <swiper :options="swiperOption" ref="imagesboxref2">
              <swiper-slide v-for="(i,index) in articleData.ImgList" :key="'articleimagesbox'+index" >
                <div class="imgbox">
                   <img :src="i.ImgUrl?i.ImgUrl:i.ImgFileName"/>
                </div>
              </swiper-slide>
              <button class="swiper-button-prev" slot="button-prev" @click="swiperprev"></button>
              <button class="swiper-button-next" slot="button-next" @click="swipernext"></button>
        </swiper> 
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        props: {
            articleData: {
                type: Object,
                default: {
                    ImgList:[]
                }
            },
        },
        data () {
            return {
                swiperOption: {
                    loop: true,
                    slidesPerView: 1,
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev"
                    }
                }
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        methods: {
            callback()
            {
                this.$emit(`closearticleimagesbox`);
            },
            swiperprev()
            {
                    this.$refs.imagesboxref2.swiper.slidePrev()
            },
            swipernext()
            {
                    this.$refs.imagesboxref2.swiper.slideNext()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .articleimagesbox{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        z-index: 1000;
        background-color: #000000b8;
        cursor: pointer;
        &>.close{
            border-radius: 50%;
            width: 30px;
            height: 30px;
            background: white;
            position: absolute;
            right: 20px;
            top: 20px;
            z-index: 9999;
            cursor: pointer;
            line-height: 30px;
            text-align: center;
            font-weight: bold;
        }
        .imgbox{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100vh;
            img{
                max-height: calc(100vh - 20px);
                max-width: calc(100% - 100px);
            }
        }
    }
</style>
